import { z } from "zod";
import * as Showdown from "showdown";

// Configure Showdown converter with common options
const converter = new Showdown.Converter({
  tables: true,
  strikethrough: true,
  tasklists: true,
  simplifiedAutoLink: true,
  openLinksInNewWindow: true,
  emoji: true,
});

export const transformerMdContentParam = z
  .string()
  .describe(
    "Must be in MARKDOWN format with proper spacing and line breaks, leave '' if not provided",
  )
  .transform((markdown) => {
    // If empty string, return empty string
    if (!markdown.trim()) {
      return "";
    }

    // Convert markdown to HTML using Showdown
    return converter.makeHtml(markdown);
  });
